import { HomeComponent } from '../../Menus/Home/home.component';
import { FileUploaderComponent } from '../../Menus/FileUploader/fileUploader.component';
import { DocumentsComponent } from '../../Menus/Documents/documents.component';
import { Injectable } from "@angular/core";


@Injectable()
export class WebXmlComponent{

    public getComponent(name:string){

        switch(name){
            case 'DocumentsComponent': return DocumentsComponent;            
            case 'FileUploaderComponent': return FileUploaderComponent;            
            default: return HomeComponent;
        }
            
    }
       
}